"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var data_point_util_1 = require("./util/data-point.util");
var framework_util_1 = require("./util/framework.util");
var operators_1 = require("rxjs/operators");
/**
 * @author astghik.mamunc on 9/12/2017.
 */
var DataPointService = /** @class */ (function () {
    function DataPointService(classifierService) {
        this.classifierService = classifierService;
        this._dataPointIdGenerator = -3; // -1 is id of achievement DataPoint
    }
    Object.defineProperty(DataPointService.prototype, "dataPointIdGenerator", {
        get: function () {
            return this._dataPointIdGenerator;
        },
        set: function (value) {
            this._dataPointIdGenerator = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Return DataPointGroups
     * @returns {Observable<any>}
     */
    DataPointService.prototype.getDataPointGroups = function () {
        return this.classifierService.loadClassifiers("DataPointGroups");
    };
    /**
     * Return DataPointGroups
     * @returns {Observable<any>}
     */
    DataPointService.prototype.getDataPointGroupsView = function () {
        return this.classifierService.loadClassifiersView("DataPointGroups");
    };
    /**
     * @param {number} dataPointGroupId An parent Id of DataPointItem
     * @returns {Observable<any>} An array of DataPointItems by parentId
     */
    DataPointService.prototype.getDataPointItems = function (dataPointGroupId) {
        return this.classifierService.loadClassifiersByParent("DataPointItems", dataPointGroupId).pipe(operators_1.map(function (classifierResponse) {
            for (var i = 0; i < classifierResponse.getData().length; ++i) {
                if (classifierResponse.getData()[i].getProperty("DeletedBy").value) {
                    classifierResponse.getData().splice(i--, 1);
                }
            }
            return classifierResponse;
        }));
    };
    /**
     * Save data point group or save data point item, when there is parentId in the parameters
     * @param {string} name A name of saved Classifier
     * @param {string} identityField A identity field of saved Classifier
     * @param {Array<Language>} languages An array of Language
     * @param categorySystemName
     * @param {number} parentId An parentId of the DataPointItem
     * @param rank
     */
    DataPointService.prototype.saveClassifier = function (name, identityField, languages, categorySystemName, parentId, rank) {
        this.classifierService.create(categorySystemName, this.createClassifier(name, identityField, languages, parentId, rank)).subscribe(function () { }, function (err) { return console.error(err); });
    };
    /**
     * Method to create classifier
     * @param {string} name A name of saved Classifier
     * @param {string} identityField A identity field of saved Classifier
     * @param {Array<Language>} languages An array of Language
     * @param {number} parentId An parentId of the DataPointItem
     * @param rank
     * @returns {Classifier} Created new Classifier
     */
    DataPointService.prototype.createClassifier = function (name, identityField, languages, parentId, rank) {
        var properties = new Map();
        properties.set(identityField, new idm_de_core_frontend_1.PropertyValueAccessor(null));
        properties.set("ID", new idm_de_core_frontend_1.PropertyValueAccessor(null));
        if (parentId) {
            properties.set(data_point_util_1.DATA_POINT_ITEM_PARENT_IDENTITY_FIELD_NAME, new idm_de_core_frontend_1.PropertyValueAccessor(parentId));
            properties.set("Rank", new idm_de_core_frontend_1.PropertyValueAccessor(rank));
        }
        properties.set("name", new idm_de_core_frontend_1.PropertyValueAccessor(framework_util_1.FUtil.getMultilingualString(languages, name)));
        properties.set("DeletedBy", new idm_de_core_frontend_1.PropertyValueAccessor(null));
        properties.set("DeletedOn", new idm_de_core_frontend_1.PropertyValueAccessor(null));
        return new idm_classifier_service_client_js_1.Classifier(properties, identityField, identityField);
    };
    DataPointService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService])
    ], DataPointService);
    return DataPointService;
}());
exports.DataPointService = DataPointService;
//# sourceMappingURL=data-point.service.js.map